export default __webpack_public_path__ + "static/media/perales_lawn_logo.4ebc0bba.svg";